// extracted by mini-css-extract-plugin
export default {"logo":"NavBar_logo__QHY62","tabs":"NavBar_tabs__8POVZ","bold":"NavBar_bold__0CRYq","underline":"NavBar_underline__lEH79"};